<template>
  <div class="menus">
<!--    <div v-for="item in getMenuList().slice(0,2)" class="menu-item" @click="handleClick(item)">-->
<!--      {{item.name}}-->
<!--    </div>-->

<!--    <div class="menu-item" v-if="getMenuList().length>2" @click="handleMore">-->
<!--      ...-->
<!--    </div>-->
  </div>
</template>

<script>
    export default {
        name: "TableMenus",
        props: ["menus", "row"],
        methods: {
            getMenuList() {
                let menus= this.menus.filter(item => {
                    let permission = this.hasPermissionGroup(item.permission);
                    if (!permission) {
                        return false;
                    }
                    if(!item.isShow || item.isShow(this.row)){
                        return  true;
                    }
                    return  false;

                });
                return menus;

            },
            handleClick(item){
              let {params=[]}=item;
              params=[this.row,...params];
              item.click && item.click.apply(this.row,params)
            },
            handleMore(){
                this.$emit("more",this.row)
            }
        }
    }
</script>

<style lang="scss" scoped>
  .menus {
    display: flex;
    width: 100%;
    align-items: center;

  }

  .menu-item {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #0066FF;
    line-height: 24px;
    cursor: pointer;
    margin-left: 16px;
    &:first-child{
      margin-left: 0px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TableMenus.vue